module.exports = __webpack_public_path__ + "static/img/t10.546d5a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/t10.png
// module id = ECi1
// module chunks = 1